
import React from 'react';
import { Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SelectField, SelectOption } from './components';

interface DataImportTabProps {
  editing: boolean;
}

// Define the component type with an Icon static property
interface DataImportTabComponent extends React.FC<DataImportTabProps> {
  Icon: typeof Upload;
}

const DataImportTab: DataImportTabComponent = ({ editing }) => {
  const dataSources: SelectOption[] = [
    { value: 'manual', label: 'Manual Upload' },
    { value: 'api', label: 'API Integration' },
    { value: 'sftp', label: 'SFTP Connection' },
    { value: 'email', label: 'Email Reporting' }
  ];

  const fileFormats: SelectOption[] = [
    { value: 'csv', label: 'CSV' },
    { value: 'xlsx', label: 'Excel (XLSX)' },
    { value: 'json', label: 'JSON' },
    { value: 'xml', label: 'XML' }
  ];

  return (
    <div className="grid gap-4">
      <SelectField
        id="import-source"
        label="External Data Sources"
        options={dataSources}
        defaultValue="manual"
        disabled={!editing}
      />
      
      <SelectField
        id="file-format"
        label="File Format"
        options={fileFormats}
        defaultValue="csv"
        disabled={!editing}
      />
      
      <div className="pt-2">
        <Button 
          variant="outline" 
          disabled={!editing}
          className="w-full gap-1"
        >
          <Upload className="h-4 w-4" />
          Configure Data Import Template
        </Button>
      </div>
    </div>
  );
};

// Assign the Icon property
DataImportTab.Icon = Upload;

export default DataImportTab;
